import { goodVibeCardFr, goodVibeDetailDialogFr } from "@domains/good-vibes/client/i18n/fr.ts";
import type { en } from "./en.ts";

export const fr: typeof en = {
    HomeProfileWidget: {
        viewProfile: "Voir le profil",
        error: "Nous n'avons pas pu charger votre profil pour le moment."
    },
    HomeEngagementWidget: {
        title: "Votre score d'engagement",
        recognition: "Reconnaissance",
        wellness: "Bien-être",
        viewMyScore: "Voir mon score d'engagement",
        ring: {
            ariaLabel: "Score d'engagement global",
            outOf: "sur {{max}}",
            valueLabel: "{{score}} sur {{max}}"
        },
        direction: {
            up: "en hausse",
            down: "en baisse"
        },
        empty: {
            title: "Votre score d'engagement prend forme",
            description: "C'est ici que votre score d'engagement apparaîtra"
        },
        error: "Nous n'avons pas pu charger votre score d'engagement pour le moment."
    },
    HomeSurveyWidget: {
        title: "Série de sondages",
        streak: {
            weekly_one: "semaine de sondages !",
            weekly_other: "semaines de sondages d'affilée !",
            bimonthly_one: "quinzaine de sondages !",
            bimonthly_other: "quinzaines de sondages d'affilée !",
            monthly_one: "mois de sondages !",
            monthly_other: "mois de sondages d'affilée !",
            quarterly_one: "trimestre de sondages !",
            quarterly_other: "trimestres de sondages d'affilée !"
        },
        markers: {
            openLabel: "Vos sondages Pulse récents — vous n'avez pas encore répondu au cycle en cours",
            answeredLabel: "Vos sondages Pulse récents — vous avez répondu au cycle en cours"
        },
        takeSurvey: "Répondre au sondage",
        allSet: "Vous êtes à jour",
        opensInNewTab: "S'ouvre dans un nouvel onglet",
        empty: {
            title: "Commencez votre série",
            description: "Répondez à votre premier sondage Pulse pour commencer votre série."
        },
        error: "Nous n'avons pas pu charger votre série de sondages pour le moment."
    },
    HomeGoalsWidget: {
        title: "Objectifs",
        headline_one: "objectif à mettre à jour",
        headline_other: "objectifs à mettre à jour",
        ownedGoal_one: "objectif",
        ownedGoal_other: "objectifs",
        viewAll: "Voir tous les objectifs",
        untitled: "Objectif sans titre",
        progressLabel: "{{progress}} %",
        progressAriaLabel: "Progression de {{title}}",
        freshness: {
            never: "Jamais mis à jour",
            today: "Mis à jour aujourd'hui",
            daysAgo_one: "Mis à jour il y a {{count}} jour",
            daysAgo_other: "Mis à jour il y a {{count}} jours",
            weeksAgo_one: "Mis à jour il y a {{count}} semaine",
            weeksAgo_other: "Mis à jour il y a {{count}} semaines"
        },
        rowAriaLabel: "{{title}} — voir tous vos objectifs",
        noGoals: "Vous n'avez pas encore d'objectifs.",
        newGoal: "Nouvel objectif",
        createError: "Erreur lors de la création de l'objectif",
        draft: "Brouillon",
        finish: "Terminer",
        draftsOnlyPrompt: "Terminez la configuration de vos objectifs",
        error: "Nous n'avons pas pu charger vos objectifs pour le moment."
    },
    HomeFeedbackWidget: {
        heading: "Feedback",
        empty: "Aucune réponse à votre feedback pour le moment.",
        someoneReplied: "Quelqu'un a répondu",
        nameReplied: "{{name}} a répondu",
        toYourFeedback: "à un feedback que vous avez partagé",
        openThread: "Ouvrir la conversation de feedback",
        viewAll: "Voir tout le feedback",
        leaveSuggestion: "Laisser une suggestion",
        error: "Nous n'avons pas pu charger votre feedback pour le moment."
    },
    HomeMeetingsWidget: {
        reviewAgenda: "Voir l'ordre du jour"
    },
    HomeReviewsWidget: {
        title: "Évaluations",
        titleWithCount_one: "{{count}} évaluation à rédiger",
        titleWithCount_other: "{{count}} évaluations à rédiger",
        dueDate: "Échéance {{date}}",
        overdue: "En retard",
        viewAll: "Voir toutes les évaluations",
        review: {
            self: "Autoévaluation",
            manager: "Évaluation du gestionnaire",
            peer: "Évaluation par les pairs",
            upward: "Évaluation ascendante"
        },
        sharedReview: {
            label: "Votre évaluation est prête à être consultée",
            attribution: "Partagée par {{name}}"
        },
        error: "Impossible de charger vos évaluations pour le moment."
    },
    HomeAgentMiniPanel: {
        inputLabel: "Posez une question à votre agent",
        sendLabel: "Envoyer à votre agent",
        placeholder1: "Mets à jour mon objectif du trimestre",
        placeholder2: "Aide-moi à préparer mon 1:1",
        placeholder3: "Rédige un feedback pour un pair"
    },
    HomeGoodVibesWidget: {
        title: "Bonnes Vibes dans votre organisation",
        viewAll: "Voir toutes les Bonnes Vibes",
        opensInNewTab: "S'ouvre dans un nouvel onglet",
        send: "Envoyer des Bonnes Vibes",
        empty: "Reconnaissez un coéquipier pour lancer les Bonnes Vibes.",
        error: "Impossible de charger les Bonnes Vibes pour le moment.",
        liveRegion: {
            loading: "Chargement des Bonnes Vibes…"
        },
        sealed: {
            badge: "Nouvelles Bonnes Vibes",
            pressAndHold: "Maintenir enfoncé pour ouvrir",
            ariaLabel: "Une nouvelle Bonne Vibe de {{recipients}} — maintenez enfoncé pour ouvrir"
        },
        composeDialog: {
            title: "Envoyer des Bonnes Vibes",
            recipientsLabel: "À",
            recipientsPlaceholder: "Ajouter quelqu'un",
            recipientsSearchPlaceholder: "Rechercher des personnes",
            recipientsSelectedLabel: "Destinataires sélectionnés",
            recipientsEmpty: "Aucun résultat",
            recipientsLoading: "Recherche en cours…",
            recipientsRemoveLabel: "Retirer {{name}}",
            subjectLabel: "Sujet",
            subjectPlaceholder: "Qu'ont-ils fait ?",
            writeOwnLabel: "Écrire le vôtre, ou choisir un sujet.",
            useTypedLabel: 'Utiliser "{{text}}"',
            customCategoryLabel: "Personnalisé",
            changeSubjectLabel: "Changer",
            messageLabel: "Message",
            messagePlaceholder: "Dites ce qu'ils ont fait et pourquoi c'était important.",
            messageCharactersLeft: "{{count}} caractères restants",
            audienceLabel: "Audience",
            directLabel: "Direct",
            directDescription: "Seulement les destinataires, leurs gestionnaires et leurs supérieurs peuvent voir ceci.",
            publicLabel: "Public",
            publicDescription: "Tous les membres de l'entreprise peuvent voir ceci.",
            fromLabel: "De {{name}}",
            cancelLabel: "Annuler",
            submitDirectLabel: "Envoyer directement",
            submitPublicLabel: "Envoyer publiquement",
            discardChangesTitle: "Abandonner cette Bonne Vibe ?",
            discardChangesBody: "Vous n'avez pas encore envoyé ceci. Quitter maintenant fera perdre ce que vous avez écrit.",
            discardChangesConfirmLabel: "Abandonner",
            discardChangesCancelLabel: "Continuer à modifier",
            successMessage: "Vous venez d'ensoleiller la journée de quelqu'un !",
            successCloseLabel: "Fermer",
            mostUsedThisMonthLabel: "Les plus utilisées ce mois-ci",
            usageCountLabel: "{{count}} utilisations ce mois-ci"
        },
        giveError: "Impossible d'envoyer. Veuillez réessayer."
    },
    HomeGoodVibeCard: {
        ...goodVibeCardFr,
        visibility: {
            public: "Publique",
            direct: "Directe"
        }
    },
    HomeGoodVibeDetailDialog: {
        ...goodVibeDetailDialogFr,
        addCommentError: "Une erreur est survenue lors de la publication de votre réponse. Veuillez réessayer.",
        editCommentSuccess: "Réponse mise à jour",
        editCommentError: "Une erreur est survenue lors de la mise à jour de votre réponse. Veuillez réessayer.",
        deleteCommentSuccess: "Réponse supprimée",
        deleteCommentError: "Une erreur est survenue lors de la suppression de votre réponse. Veuillez réessayer."
    },
    HomeFeedbackThreadDialog: {
        title: "Feedback",
        close: "Fermer",
        liveRegion: {
            loading: "Chargement de la conversation"
        },
        error: "Nous n'avons pas pu charger cette conversation pour le moment.",
        status: {
            awaiting: "En attente de réponse"
        }
    },
    HomeFeedbackReplyComposer: {
        textareaLabel: "Répondre au feedback",
        placeholder: "Répondre…",
        send: "Envoyer la réponse",
        sending: "Envoi de la réponse…",
        successToast: "Réponse envoyée",
        errorToast: "Impossible d'envoyer votre réponse. Veuillez réessayer.",
        replyAnonymously: "Répondre anonymement",
        revealIdentityErrorToast: "Impossible de mettre à jour l'anonymat pour cette conversation. Veuillez réessayer."
    }
};
